<template>
  <div class="home-dashboard">
    <div class="dashboard-grid">
      <div class="home-card pie-card">
        <chart-component />
        <div class="pie-footnote">
          <span class="info-dot">i</span>
          <span>El estado de ánimo se calcula con base en las respuestas de las encuestas de la empresa.</span>
        </div>
      </div>
      <mood-card-component />
    </div>
    <quick-actions-component />
  </div>
</template>

<script>
import chartComponent from "@/views/chart/pages/components/chart_component.vue";
import moodCardComponent from "./mood_card_component.vue";
import quickActionsComponent from "./quick_actions_component.vue";

export default {
  name: "home_whiteboard",
  components: {
    chartComponent,
    moodCardComponent,
    quickActionsComponent,
  },
};
</script>

<style lang="css" scoped>
.home-dashboard {
  width: 100%;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 22px;
  margin-bottom: 22px;
}

.home-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 26px 28px;
  box-shadow: 0 10px 30px -14px rgba(59, 22, 96, 0.16);
  display: flex;
  flex-direction: column;
}

.pie-card {
  overflow: hidden;
}

.pie-footnote {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #f5f3ff;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 12.5px;
  color: #6e6480;
}

.info-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #5b21b6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  flex-shrink: 0;
}

@media (max-width: 900px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}
</style>
  